import en from '../../../public/locales/en/peacecover.json'
import ko from '../../../public/locales/ko/peacecover.json'
import ja from '../../../public/locales/jp/peacecover.json'

export type SiteLocale = 'en' | 'ko' | 'ja'
export type SiteCopy = typeof en
export const siteCopies: Record<SiteLocale, SiteCopy> = { en, ko, ja }
export const sitePaths: Record<SiteLocale, string> = { en: '/', ko: '/ko/', ja: '/ja/' }
export const siteLanguages: Array<{ code: SiteLocale; label: string }> = [
  { code: 'ko', label: '한국어' }, { code: 'en', label: 'English' }, { code: 'ja', label: '日本語' },
]

export function translate(copy: SiteCopy) {
  return (key: string): string => {
    const value = key.split('.').reduce<unknown>((node, part) =>
      node && typeof node === 'object' ? (node as Record<string, unknown>)[part] : undefined, copy)
    if (typeof value !== 'string') throw new Error(`Missing site copy: ${key}`)
    return value
  }
}
